import * as CommonConstants from "utilities/CommonConstants";

// config取得キー
export const CAMPUS_HOLIDAY: string = `holidays`;
export const CALENDAR_LOCALE: string = `calendarLocale`;
export const CALENDAR_DAYS_OF_WEEK: string = `calendarDaysOfWeek`;
export const CALENDAR_SLOTDURATION: string = `calendarSlotduration`;
export const CALENDAR_START_TIME_AM: string = `calendarStartTimeAm`;
export const CALENDAR_END_TIME_AM: string = `calendarEndTimeAm`;
export const CALENDAR_START_TIME_PM: string = `calendarStartTimePm`;
export const CALENDAR_END_TIME_PM: string = `calendarEndTimePm`;
export const BOOKING_START_TIME_AM: string = `bookingStartTimeAm`;
export const BOOKING_END_TIME_AM: string = `bookingEndTimeAm`;
export const BOOKING_START_TIME_PM: string = `bookingStartTimePm`;
export const BOOKING_END_TIME_PM: string = `bookingEndTimePm`;
export const BOOKING_BOOKINGABLE_DAYS: string = `bookingBookingableDays`;
export const BOOKING_BOOKINGABLE_LIMIT_AM: string = `bookingBookingableLimitAm`;
export const BOOKING_BOOKINGABLE_LIMIT_PM: string = `bookingBookingableLimitPm`;
export const BOOKING_INTERVAL_TAKEOUT: string = `bookingIntervalTakeout`;
export const BOOKING_INTERVAL_POMPOUT1: string = `bookingIntervalPompout1`;
export const BOOKING_INTERVAL_POMPOUT2: string = `bookingIntervalPompout2`;
export const BOOKING_DEADLINE_AM: string = `bookingDeadlineAm`;
export const BOOKING_DEADLINE_PM: string = `bookingDeadlinePm`;
export const KEY_SOLVENT_LIMIT_COUNT: string = `solventLimitCount`;
export const KEY_SOLVENT_LIMIT_CAPACITY_KG: string = `solventLimitCapacityKg`;
export const KEY_SOLVENT_LIMIT_CAPACITY_L: string = `solventLimitCapacityL`;
export const EMAIL_DOMAIN_LIST: string = `emailDomainList`;
export const BOOKING_DIETHYLETHER_DEHYDRATION_EXTENSION_NUMBER: string = `bookingDiethyletherDehydrationExtensionNumber`;
export const WASTE_LINK: string = `wasteLink`;

/**
 * config取得クラス
 */
export class ConfigGetter {
    /**
     * sessionStrageで管理しているconfigから指定の値を取得する
     * @param key 取得対象のキー
     * @return 指定されたキーに紐づく値
     */
    static get = (key: string) => {
        let config = sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG);
        let value = ``;
        if (typeof config === `string`) {
            let arr = JSON.parse(config);
            value = arr[key];
        }
        return value;
    };

    static getNum = (key: string): number => {
        let config = sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG);
        let value = ``;
        if (typeof config === `string`) {
            let arr = JSON.parse(config);
            value = arr[key];
            if (typeof value === `number`) {
                return parseInt(value);
            }
        }
        return 0;
    };

    static getList = (key: string) => {
        let config = sessionStorage.getItem(CommonConstants.SESSION_KEY_CONFIG);
        let value = [];
        if (typeof config === `string`) {
            let arr = JSON.parse(config);
            value = arr[key];
        }
        return value;
    };
}
